import { render, staticRenderFns } from "./phoneExtListing.vue?vue&type=template&id=4f0b1dd4&"
import script from "./phoneExtListing.vue?vue&type=script&lang=js&"
export * from "./phoneExtListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports